module.exports = __webpack_public_path__ + "img/Chevron.ba98f13a.svg";